"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _ApiRequest = _interopRequireDefault(require("../api/ApiRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Utility component to display different variation depending on a request state.
 *
 * Copyright (C) 2018B Noom, Inc.
 * @author hubert
*/
var instance = function instance(value) {
  return _lodash["default"].isFunction(value) ? value() : value || null;
};

var _default = function _default(props) {
  if (!props.request) {
    if (props.waitingAs) {
      return instance(props[props.waitingAs]);
    }

    return instance(props.waiting);
  }

  if (props.request.state === _ApiRequest["default"].state.LOADING) {
    if (props.loadingAs) {
      return instance(props[props.loadingAs]);
    }

    return instance(props.loading);
  }

  if (props.request.state === _ApiRequest["default"].state.SUCCESS) {
    if (props.successAs) {
      return instance(props[props.successAs]);
    }

    return instance(props.success);
  }

  if (props.request.state === _ApiRequest["default"].state.ERROR) {
    if (props.errorAs) {
      return instance(props[props.errorAs]);
    }

    return instance(props.error);
  }
};

exports["default"] = _default;